<template>
  <v-dialog
    :value="isOpen"
    activator="parent"
    width="420"
    @click:outside="onCloseHandler"
    @keydown.esc="onCloseHandler"
  >
    <v-card>
      <form @submit.prevent="onSubmitHandler">
        <v-col cols="12">
          <v-select
            v-model="form.reason"
            :items="cancelReasons"
            :label="mess.order_history_reason_for_close"
            item-text="reason"
            item-value="id"
            outlined
            dense
            hide-details
            class="mt-4"
          />

          <v-textarea
            v-model="form.comment"
            :label="mess.order_history_reason_for_close_comment"
            value=""
            name="reason-for-close"
            outlined
            dense
            auto-grow
            class="mt-4"
          />

          <v-file-input
            v-model="form.file"
            outlined
            dense
            :placeholder="mess.order_reason_cancel_download_file"
            :label="mess.order_reason_cancel_download_file"
          />

          <v-row
            class="ma-0 mt-4"
            align="center"
            justify="end"
          >
            <v-btn
              color="primary"
              class="mr-2"
              type="submit"
            >
              {{ mess.order_history_save }}
            </v-btn>

            <v-btn
              outlined
              color="primary"
              @click="onCloseHandler"
            >
              {{ mess.order_history_cancel }}
            </v-btn>
          </v-row>
        </v-col>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import notifications from "@/models/notificationTemplates";

// Добавил константу с названиями полей для запроса,
// так как данные в тело запроса вставляются через formData,
// а названия полей, которые ождиает бэк не совсем понятные
const request_keys = {
  file: "inputfile",
  reason: "reasonId",
  comment: "comment"
};

export default {
  name: "DealActionsDialog",
  props: {
    cancelReasons: {
      type: Array,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    order: {
      type: Object,
      required: true
    }
  },
  inject: ["mess"],
  data() {
    return {
      form: {
        file: null,
        reason: null,
        comment: null
      }
    };
  },
  methods: {
    resetForm() {
      for (const key in this.form) {
        this.form[key] = null;
      }
    },
    async cancelOrder() {
      const formData = new FormData();

      formData.append("orderId", this.order.real_id);

      for (const key in this.form) {
        formData.append(request_keys[key], this.form[key]);
      }

      try {
        await axios.post("/api/CanselOrder", formData);
        this.$emit("open:snackbar", notifications.success.inquiryClosed);
      } catch (error) {
        console.error(error);
        this.$emit("open:snackbar", notifications.error.base);
      }
    },
    async onSubmitHandler() {
      await this.cancelOrder();
      this.resetForm();
      this.$emit("update:orders");
      this.$emit("update:is-open", false);
    },
    onCloseHandler() {
      this.resetForm();
      this.$emit("update:is-open", false);
    }
  }
};
</script>
